import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ComunidadeNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-luxury-dark/95 backdrop-blur-xl shadow-2xl border-b border-gold-500/20'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-between h-24">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer group"
          >
            <img
              src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
              alt="Carta do Eu Futuro"
              className="w-20 h-20 object-contain rounded-full bg-white p-0.5 flex-shrink-0 group-hover:scale-110 group-hover:drop-shadow-[0_0_14px_rgba(201,164,64,0.55)] transition-all duration-300"
            />
            <span className="font-['Playfair_Display'] text-lg font-semibold text-white hidden sm:block">
              Carta do Eu Futuro
            </span>
          </button>

          <div className="flex items-center gap-3 sm:gap-8">
            <button
              onClick={() => navigate('/')}
              className="font-['Montserrat'] text-xs uppercase tracking-wider text-white/70 hover:text-gold-400 transition-colors duration-300 cursor-pointer whitespace-nowrap hidden sm:block"
            >
              Início
            </button>
            <button
              onClick={() => navigate('/faq')}
              className="font-['Montserrat'] text-xs uppercase tracking-wider text-white/70 hover:text-gold-400 transition-colors duration-300 cursor-pointer whitespace-nowrap hidden sm:block"
            >
              FAQ
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="font-['Montserrat'] text-xs uppercase tracking-wider bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <span className="hidden sm:inline">Minhas Cartas</span>
              <span className="sm:hidden">Entrar</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ComunidadeNavbar;
